import React, { useState, useEffect } from "react";



import { collection, query, addDoc, where, getDocs, doc, updateDoc } from "firebase/firestore";
import db from "./Firebase";
import { useNavigate, Link, useParams } from 'react-router-dom';
import Swal from "sweetalert2";

function CourseVideoUpdate() {
    const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState("");
    const [videoId, setVideoId] = useState("");
    const [day, setDay] = useState("");
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();


    useEffect(() => {
        const storedUsername = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        const storedRemember = localStorage.getItem("remember");

        setEmail(storedUsername)

        if (storedRemember === "false" || !storedUsername || !storedPassword) {
            navigate('/signin');
        }

    }, []);

    useEffect(() => {
        const fetchCourses = async () => {
            const querySnapshot = await getDocs(collection(db, "nv_courses"));
            const courseList = querySnapshot.docs.map(doc => doc.data().course_name);
            setCourses(courseList);
        };

        fetchCourses();
    }, []);

    const updateLessonTimes = async () => {
        if (!selectedCourse || videoId.trim() === "" || day.trim() === "") {
            Swal.fire("Error", "Please fill all fields!", "error");
            return;
        }

        setLoading(true);

        try {
            // ✅ Update enrolled users
            const enrolledQuery = query(
                collection(db, "nv_enrolled_courses"),
                where("course_name", "==", selectedCourse)
            );
            const enrolledSnapshot = await getDocs(enrolledQuery);

            if (!enrolledSnapshot.empty) {
                let updatedCount = 0;
                for (const docSnap of enrolledSnapshot.docs) {
                    const courseRef = doc(db, "nv_enrolled_courses", docSnap.id);
                    const courseData = docSnap.data();

                    const updatedLessons = courseData.lessons.map((lesson, index) =>
                        index === parseInt(day) - 1 ? { ...lesson, video_link: videoId } : lesson
                    );

                    await updateDoc(courseRef, { lessons: updatedLessons });
                    updatedCount++;
                }
                Swal.fire("Success", `Updated lessons for ${updatedCount} enrolled users!`, "success");
            }

            // ✅ Update only one course in `nv_courses`
            const courseQuery = query(
                collection(db, "nv_courses"),
                where("course_name", "==", selectedCourse)
            );
            const courseSnapshot = await getDocs(courseQuery);

            if (!courseSnapshot.empty) {
                const courseDoc = courseSnapshot.docs[0]; // Only update the first match
                const courseRef = doc(db, "nv_courses", courseDoc.id);
                const courseData = courseDoc.data();

                const updatedLessons = courseData.lessons.map((lesson, index) =>
                    index === parseInt(day) - 1 ? { ...lesson, video_link: videoId } : lesson
                );

                await updateDoc(courseRef, { lessons: updatedLessons });

                Swal.fire("Success", "Updated course data successfully!", "success");
            } else {
                Swal.fire("Error", "No matching course found!", "error");
            }

            // ✅ Add log entry in "nv_backend_logs"
            const logEntry = {
                created_date: new Date(), // Current timestamp
                email: email || "unknown", // Fallback if email is missing
                page: "CourseVideoUpdate",
                action: `Updated video ID: ${videoId} for enrolled users on day ${day} for course: ${selectedCourse}`,
            };

            await addDoc(collection(db, "nv_backend_logs"), logEntry);
            console.log("Log entry added:", logEntry);

        } catch (error) {
            console.error("Error updating lesson times:", error);
            Swal.fire("Error", "Failed to update lesson times!", "error");
        } finally {
            setLoading(false);
        }
    };


    return (
        // <div className="container mt-4">
        //     <h2>Update Course Video ID</h2>

        //     <label>Course Name:</label>
        //     <select className="form-control" value={selectedCourse} onChange={e => setSelectedCourse(e.target.value)}>
        //         <option value="">Select Course</option>
        //         {courses.map((course, index) => (
        //             <option key={index} value={course}>{course}</option>
        //         ))}
        //     </select>

        //     <label className="mt-3">Video ID:</label>
        //     <input type="text" className="form-control" value={videoId} onChange={e => setVideoId(e.target.value)} />

        //     <label className="mt-3">Day:</label>
        //     <input type="number" className="form-control" placeholder="eg. 1 2 3 4 ..." value={day} onChange={e => setDay(e.target.value)} />

        //     <button className="btn btn-primary mt-4" onClick={updateLessonTimes} disabled={loading}>
        //         {loading ? "Updating..." : "Submit"}
        //     </button>
        // </div>

        <>
            <div className="p-2 d-flex justify-content-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="p-3">
                <h6 className="mb-2"> <h2>Update Course Video ID</h2></h6>
                <div className="card-header pb-0 px-3 d-flex justify-content-end">

                    <Link to="/course_attendance_update">
                        <button className="btn btn-success btn-sm mr-3" >
                            Course Attendance Update
                        </button>
                    </Link>
                    <Link to="/course_timestamp_update">
                        <button className="btn btn-success btn-sm" >
                            Course Timestamp Update
                        </button>
                    </Link>

                </div>

                <div className="table-responsive fix-width scroll-inner">
                    <label>Course Name:</label>
                    <select className="form-control" value={selectedCourse} onChange={e => setSelectedCourse(e.target.value)}>
                        <option value="">Select Course</option>
                        {courses.map((course, index) => (
                            <option key={index} value={course}>{course}</option>
                        ))}
                    </select>

                    <label className="mt-3">Video ID:</label>
                    <input type="text" className="form-control" value={videoId} onChange={e => setVideoId(e.target.value)} />

                    <label className="mt-3">Day:</label>
                    <input type="number" className="form-control" placeholder="eg. 1 2 3 4 ..." value={day} onChange={e => setDay(e.target.value)} />

                    <button className="btn btn-primary mt-4" onClick={updateLessonTimes} disabled={loading}>
                        {loading ? "Updating..." : "Submit"}
                    </button>
                </div>
            </div>
        </>
    );
}

export default CourseVideoUpdate;